import { Component } from "../component"
import Swiper, { Thumbs, Keyboard, Pagination, A11y } from "swiper"

export class BlogArticleCarousel extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      mainSwiperContainer: ".main-swiper",
      thumbsSwiperContainer: ".thumbs-swiper",
    }
  }

  initSwiper() {
    const { mainSwiperContainer, thumbsSwiperContainer } = this.$ui

    this.thumbsSwiper = new Swiper(thumbsSwiperContainer, {
      modules: [Keyboard, Pagination, A11y],
      spaceBetween: 9,
      slidesPerView: 5.5,
      touchRatio: 0.2,
      slideToClickedSlide: true,
      breakpoints: {
        1024: {
          slidesPerView: 14,
          spaceBetween: 30,
        },
      },
    })

    this.mainSwiper = new Swiper(mainSwiperContainer, {
      modules: [Thumbs, Keyboard, Pagination, A11y],
      spaceBetween: 10,
      slidesPerView: 1.05,
      allowTouchMove: true,
      centeredSlides: true,
      thumbs: {
        swiper: this.thumbsSwiper,
      },
      breakpoints: {
        1024: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
    })
  }

  created() {
    this.initSwiper()
  }
}
